export function clampFieldValue(vm, fieldName, minValue, maxValue, enforceNonNegativity = false) {
  let fieldValue = Number(vm[fieldName]);

  if (isNaN(fieldValue)) {
    fieldValue = 0;
  }

  if (enforceNonNegativity) {
    fieldValue = Math.max(fieldValue, 0);
  }

  if (typeof maxValue !== 'undefined') {
    fieldValue = Math.max(fieldValue, minValue);
    fieldValue = Math.min(fieldValue, maxValue);
  } else {
    fieldValue = Math.max(fieldValue, minValue);
  }

  vm[fieldName] = fieldValue;
}



export function enforceNonNegativity(event, field) {
  const newValue = parseFloat(event.target.value);
  if (isNaN(newValue) || newValue < 0) {
    this[field] = 0.001;
  } else {
    this[field] = newValue;
  }
}